import { i18n } from '@localization'
import {
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'

import { getScratchCardList, onScratchCardReveal } from './functions'

function useScratchCardList() {
  return useInfiniteQuery(
    ['scratchCardList'],
    ({ pageParam = 0 }) => {
      return getScratchCardList(pageParam || 0)
    },
    {
      getNextPageParam: (lastPage, pages) => {
        if (pages.length * 10 <= lastPage.total) {
          return lastPage.nextOffset
        }
        return undefined
      },
    }
  )
}

function useScratchCardReveal() {
  const queryClient = useQueryClient()
  const toast = useToast()
  return useMutation(onScratchCardReveal, {
    onSuccess(response) {
      queryClient.invalidateQueries({ queryKey: ['scratchCardList'] })
      queryClient.invalidateQueries({ queryKey: ['userTotalEarning'] })
    },
    onError(error) {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.trainingFailed'),
        hideAfter: 3000,
      })
    },
  })
}
export { useScratchCardList, useScratchCardReveal }
